import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Link as GatsbyLink } from 'gatsby'
import { parseMarginOrPadding } from '@helpers'

const oneRequiredPropsCheck = (props, propName, componentName) => {
  if (!props.to && !props.click && !props.href) {
    return new Error(
      `'to' or 'href' or 'click' is required by '${componentName}' component`
    )
  }
}

const propTypes = {
  to: oneRequiredPropsCheck,
  href: oneRequiredPropsCheck,
  click: oneRequiredPropsCheck,
  children: PropTypes.node,
  className: PropTypes.string,
  newtab: PropTypes.bool
}

const LinkComponent = ({
  to,
  href,
  children,
  click,
  className,
  newtab,
  ...rest
}) => {
  if (to) {
    return (
      <GatsbyLink className={className} to={to} {...rest}>
        {children}
      </GatsbyLink>
    )
  } else if (href) {
    return (
      <a
        target={newtab ? '_blank' : ''}
        rel={"noreferrer"}
        className={className}
        href={href}
        {...rest}
      >
        {children}
      </a>
    )
  } else if (click) {
    return (
      <a className={className} onClick={click} {...rest}>
        {children}
      </a>
    )
  } else {
    return <></>
  }
}

const Link = styled(LinkComponent)`
  color: ${(props) => props.theme.colors.primary};
  text-decoration: none;
  transition: all 300ms ease-out;
  ${'' /* margin: ${props => marginZero(props)}; */}
  margin: ${({ margin }) => parseMarginOrPadding(margin)};
  :hover {
    color: ${(props) => props.theme.palette.primary['500']};
    cursor: pointer;
  }
`

LinkComponent.propTypes = propTypes
export default Link
